//Parroquia Portuguesa
const munAguaBlanca = ['Agua Blanca'];
const munAraure = ['Araure', 'Río Acarigua'];
const munEsteller = ['Esteller', 'Uveral'];
const munGuanare = [
  'Guanare',
  'Córdoba',
  'San José de la Montaña',
  'San Juan de Guanaguanare',
  'Virgen de la Coromoto',
];
const munGuanarito = ['Guanarito', 'Trinidad de la Capilla', 'Divina Pastora'];
const munMonseñorJoséVicentedeUnda = [
  'Monseñor José Vicente de Unda',
  'Peña Blanca',
];
const munOspino = ['Ospino', 'Aparición', 'La Estación'];
const munPáezPortuguesa = ['Páez', 'Payara', 'Pimpinela', 'Ramón Peraza'];
const munPapelón = ['Papelón', 'Caño Delgadito'];
const munSanGenarodeBoconoito = ['San Genaro de Boconoito', 'Antolín Tovar'];
const munSanRafaeldeOnoto = [
  'San Rafael de Onoto',
  'Santa Fe',
  'Thermo Morles',
];
const munSantaRosalía = ['Santa Rosalía', 'Florida'];
const munSucrePortuguesa = [
  'Sucre',
  'Concepción',
  'San Rafael de Palo Alzado',
  'Uvencio Antonio Velásquez',
  'San José de Saguaz',
  'Villa Rosa',
];
const munTurén = [
  'Capital Turén',
  'Canelones',
  'Santa Cruz',
  'San Isidro Labrador',
];

export const esPortuguesa = [
  {
    municipio: 'Agua Blanca',
    parroquias: munAguaBlanca,
  },
  {
    municipio: 'Araure',
    parroquias: munAraure,
  },
  {
    municipio: 'Esteller',
    parroquias: munEsteller,
  },
  {
    municipio: 'Guanare',
    parroquias: munGuanare,
  },
  {
    municipio: 'Guanarito',
    parroquias: munGuanarito,
  },
  {
    municipio: 'Monseñor José Vicentede Unda',
    parroquias: munMonseñorJoséVicentedeUnda,
  },
  {
    municipio: 'Ospino',
    parroquias: munOspino,
  },
  {
    municipio: 'Páez',
    parroquias: munPáezPortuguesa,
  },
  {
    municipio: 'Papelón',
    parroquias: munPapelón,
  },
  {
    municipio: 'San Genaro de Boconoito',
    parroquias: munSanGenarodeBoconoito,
  },
  {
    municipio: 'San Rafael de Onoto',
    parroquias: munSanRafaeldeOnoto,
  },
  {
    municipio: 'Santa Rosalía',
    parroquias: munSantaRosalía,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucrePortuguesa,
  },
  {
    municipio: 'Turén',
    parroquias: munTurén,
  },
];
